import { useLoggedOutSuppliersPageQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageQueryParams";

export const useLoggedOutSuppliersPageZeroIndexedPageNumberQueryParams = () => {
  const { queryParams } = useLoggedOutSuppliersPageQueryParams();
  const pageNumber = queryParams.page ? parseInt(queryParams.page, 10) - 1 : 0;

  return { pageNumber };
};
